import ToastDialog from "components/Common/ToastDialog";
import withRouter from "components/Common/withRouter";
import { ErrorMessage, useFormik } from "formik";
import { callCheckUdyamNumber, callGetGSTINDetails, callGetPanDetails } from "http/gstin/gstin";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Loader from "react-spinner-loader";
import API_SERVICES from "constants/app.constants";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import * as Yup from "yup";
import { getRoleByEntityType } from "../../http/fundLync/role.helper"
//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle";

import { useAsyncDebounce } from "react-table";
import {
  getDropDownList
} from "../../http/fundLync/dropdown.helper";
import {
  addEntity,
  callGetCity,
  callAnchorList,
  callGetState,
  checkEntityExistOrNot,
  getCIUser,
  getCIUserRolewise,
} from "../../http/fundLync/entityAndAddress.helper";
//redux
import { uId, dateFormatChange, decryptedValue } from "common/utility";
import { formatDateString, formatDateString1 } from "pages/EntityDashboard/borrowingProfile";
import { callGetCINDetails } from "http/cin/cin";
import { callGetCIUser } from "http/fundLync/dealFinancier";

const AddEntity = (props) => {
  document.title = "Add Entity | Fundlync";
  const navigate = useNavigate();
  const [entity] = useState(null);
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);

  const entityType = urlParams.get("type");
  const decodedEntityType = entityType || null;

  const [isNonFinSelected, setIsNonFinSelected] = useState(true);
  const [isFinSelected, setIsFinSelected] = useState(false);
  const [isMSMESelected, setIsMSMESelected] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isAlready, setIsAlready] = useState(false);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [entityTypeList, setEntityTypeList] = useState([]);
  const [nonFinTypeList, setNonFinTypeList] = useState([]);
  const [finTypeList, setFinTypeList] = useState([]);
  const [msmeTypeList, setMsmeTypeList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [roleList, setRoleList] = useState([])
  const currentDate = new Date().toISOString().split("T")[0];
  const [isConstitution, setIsConstitution] = useState(false);
  const [managerList, setManagerList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [partnerList, setPartnerList] = useState([]);

  const [selectedAnchors, setSelectedAnchors] = useState("");
  const [anchorList, setAnchorList] = useState([]);
  const [selectedMulti, setSelectedMulti] = useState([]);
  const [msmeDropDown, setMsmeDropDown] = useState([]);
  const [msmeNmsme, setMsmeType] = useState('');
  const [isCounterparty, setIsCounterparty] = useState(false);
  const [regionList, setReigonList] = useState([]);
  const [agencyNameList, setAgencyNameList] = useState([]);
  const [ratingList, setRatingList] = useState([]);

  let userDetails = decryptedValue(localStorage.getItem("user"));

  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      entityName: entity?.entityName || "",
      anchors: [],
      msmeNonmsme: entity?.msmeNonmsme || "",
      udyamNumber: entity?.udyamNumber || "",
      roleId: entity?.roleId || "",
      gstnIn: entity?.gstnIn || "",
      cin: entity?.cin || "",
      pan: entity?.pan || "",
      entityConstitution: entity?.entityConstitution || "",
      natureOfBusiness: entity?.natureOfBusiness || "",
      entityType: entity?.entityType ,
      nonFinancierType: entity?.nonFinancierType || "",
      msmeType: entity?.msmeType || "",
      region: entity?.region || "",
      companyDescription: entity?.companyDescription || "",
      //Newly Added
      programManager:entity?.programManager || "",
      anchorPoc: entity?.anchorPoc || "" ,
      anchorContactNo :entity?.anchorContactNo || "",
      anchorEmail: entity?.anchorEmail || "",
      designationValue : entity?.designationValue || "",
      programOwner: entity?.programOwner || "",
      fiPartnershipManager: entity?.fiPartnershipManager || "",
      financierType: entity?.financierType || "",
      address1: entity?.address1 || "",
      address2: entity?.address2 || "",
      address3: entity?.address3 || "",
      city: entity?.city || "",
      state: entity?.state || "",
      pincode: entity?.pincode || "",
      firstName: entity?.firstName || "",
      lastName: entity?.lastName || "",
      email: entity?.email || "",
      mobileNo: entity?.mobileNo || "",
      dateOfIncorporation: entity?.dateOfIncorporation || "",
      addressType: entity?.addressType || "",
      // poc
      firstname: (entity?.firstname) || "",
      lastname: (entity?.lastname) || "",
      email2: (entity?.email2) || "",
      contactNumber: (entity?.contactNumber) || "",
      designation: (entity?.designation) || "",
      dateOfBirth: (entity?.dateOfBirth) || "",
      // credit rating
      creditRating: entity?.creditRating || "",
      agencyName: entity?.agencyName || "",
      ratedDate: entity?.ratedDate || currentDate,
      turnOver: entity?.turnOver || "",
      totalPurchase: entity?.totalPurchase||"",
    },
    validationSchema: Yup.object({
      entityName: Yup.string().required("Please Enter Entity Name"),
      msmeNonmsme:isNonFinSelected
      ? Yup.string()
      : Yup.string(),
      udyamNumber: Yup.string()
      .matches(
        /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/,
        "Udyam number must be in the format UDYAM-XX-00-0000000"
      ),
      gstnIn: Yup.string().matches(API_SERVICES.GSTN_PATTERN, "Enter correct GSTIN!"),
      cin: isConstitution
        ? Yup.string().matches(API_SERVICES.CIN_PATTERN, "Enter a valid CIN number")
        : Yup.string().matches(API_SERVICES.CIN_PATTERN, "Enter a valid CIN number"),
      pan: Yup.string()
        .matches(API_SERVICES.PAN_PATTERN, "Enter a valid PAN number"),
      entityConstitution: Yup.string().required(
        "Please Enter Entity Constitution"
      ),
      region: Yup.string().required("Please select a Region"),
      programManager: Yup.string(),
      anchorPoc: isNonFinSelected 
       ? Yup.string()
        :Yup.string(),
      designationValue: Yup.string(),
      anchorContactNo: isNonFinSelected
        ? Yup.string()
            .matches(/^[1-9][0-9]*$/, "Mobile number must not start with zero and should contain only digits")
            .min(10, "Mobile number must be at least 10 digits")
            .max(10, "Mobile number must be at most 10 digits")
        : Yup.string()
            .matches(/^[1-9][0-9]*$/, "Mobile number must not start with zero and should contain only digits")
            .min(10, "Mobile number must be at least 10 digits")
            .max(10, "Mobile number must be at most 10 digits"),
      anchorEmail: Yup.string().email("Invalid email address"),
      programOwner: isNonFinSelected 
        ?  Yup.string().required("Please select a Relationship Manager")
        :Yup.string(),
      fiPartnershipManager: Yup.string(),
      natureOfBusiness: isNonFinSelected
        ? Yup.string()
        : Yup.string(),
      entityType: Yup.string().required("Please Select Entity Type"),
      nonFinancierType: isNonFinSelected
        ? Yup.string()
        : Yup.string(),
      msmeType: isMSMESelected
        ? Yup.string()
        : Yup.string(),
      financierType: isFinSelected
        ? Yup.string()
        : Yup.string(),
      creditRating: !isFinSelected
        ? Yup.string()
        : Yup.string(),
      companyDescription: Yup.string(),
      address1: Yup.string(),
      address2: Yup.string(),
      address3: Yup.string(),
      addressType: Yup.string(),
      city: Yup.string(),
      state: Yup.string(),
      pincode: Yup.string().matches(/^[0-9]{6}$/, "Pincode must be exactly 6 positive digits")
        .typeError("Pincode Must be a Number"),
      firstName: isOpen
        ? Yup.string().required("Please Enter First Name")
        : Yup.string(),
      roleId: isOpen
        ? Yup.string().required("Please Select Role Type")
        : Yup.string(),
      lastName: isOpen
        ? Yup.string().required("Please Enter Last Name")
        : Yup.string(),
      email: isOpen
        ? Yup.string().required("Please Enter Email")
        : Yup.string(),
      mobileNo: isOpen
        ? Yup.string()
          .required("Please Enter Mobile No")
          .matches(/^\d{10}$/, "Mobile Number must be exactly 10 digits")
        : Yup.string(),
      dateOfIncorporation: Yup.string(),
      // poc
      firstname: Yup.string(),
      lastname: Yup.string(),
      contactNumber: Yup.string()
          .matches(/^[1-9][0-9]*$/, "Mobile number must not start with zero and should contain only digits")
          .min(10, "Mobile number must be at least 10 digits")
          .max(10, "Mobile number must be at most 10 digits"),
      email2: Yup.string().email("Invalid email address"),
      designation: Yup.string(),
      dateOfBirth: Yup.string(),
      anchors: isCounterparty
      ? Yup.array().min(1, "Please select at least one anchor")
      : Yup.array(),
      turnOver: Yup.number()
        .typeError("Turnover Amount must be a number")
        .min(0, "Turnover cannot be negative")
        .max(99999999999999, "Turnover cannot more than 14 digits"),
        totalPurchase: Yup.number()
        .typeError("Total Purchase must be a number")
        .min(0, "Total Purchase cannot be negative")
        .max(99999999999999, "Total Purchase cannot be more than 14 digits"),
    }),
    onSubmit: (values) => { 
      const entity = {
        entityName: values.entityName,
        udyamNumber:values.udyamNumber,
        entityType: values.entityType,
        anchors : values.anchors,
        msmeType: values.msmeType,
        gstnIn: values.gstnIn,
        cin: values.cin,
        pan: values.pan,
        entityConstitution: values.entityConstitution,
        region: values.region || '',
        natureOfBusiness: values.natureOfBusiness,
        businessType: values.businessType || "",
        programManager: values.programManager || "",
        anchorPoc: values.anchorPoc || "",
        anchorContactNo: values.anchorContactNo || "",
        anchorEmail: values.anchorEmail || "",
        designationValue : values.designationValue || "",
        programOwner: values.programOwner || "",
        fiPartnershipManager: values.fiPartnershipManager,
        nonFinancierType: values.nonFinancierType,
        msmeNoNmsme: values.msmeNonmsme,
        
        financierType: values.financierType,
        isVerify: true,
        dateOfIncorporation: values.dateOfIncorporation,
        companyDescription: values.companyDescription,
        address1: values.address1,
        city: values.city,
        state: values.state,
        addressType: values.addressType,
        pincode: values.pincode,
        firstname: values.firstname,
        lastname: values.lastname,
        email2: values.email2,
        contactNumber: values.contactNumber,
        designation: values.designation,
        dateOfBirth: values.dateOfBirth,
        turnOver: values?.turnOver || '',
        totalPurchase:values?.totalPurchase||'',
      };

      if (values.agencyName || values.creditRating) {
        entity.creditRating = values.creditRating;
        entity.agencyName = values.agencyName;
        entity.ratedDate = values.ratedDate;
      }

      if (values.address2) {
        entity.address2 = values.address2;
      }

      if (values.address3) {
        entity.address3 = values.address3;
      }

      if (values.firstName) {
        entity['firstName'] = values.firstName
        entity['lastName'] = values.lastName
        entity['email'] = values.email
        entity['mobileNo'] = String(values.mobileNo)
        entity['roleId'] = values.roleId
      }
      setSaveLoader(true)
      addEntity(entity)
        .then((response) => {
          if ((response.code == 201 && response.status)) {
            setSaveLoader(false)
            setToastInfo({
              message: "Entity Details Saved",
              showToast: true,
              role: "success",
            });
            navigate(`/${userDetails.roleName}/listEntity`);
          } else {
            setSaveLoader(false)
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(f => {
          setSaveLoader(false);
        });
    },
    
    // }
  });

  const handlClick = () => {
    let set = !isOpen;
    setIsOpen(set);
  };

  const onGSTINChange = useAsyncDebounce((value) => {
    findGSTINDetails(value);
  }, 400);

  const onPanChange = useAsyncDebounce((value) => {
    if (!validation.errors.pan) findPanDetails(value);
  }, 400);

  const onCINChange = useAsyncDebounce((value) => {
    findCINDetails(value);
  }, 400);

  const findCINDetails = (cin) => {
    setLoader(true);
    callGetCINDetails({ cin: cin })
      .then(async (result) => {
        if (result.code == 200 && result.status) {
          if (await checkIfalreadyExist({cin})) {
            setIsAlready(true);
            setToastInfo({
              message: "CIN already registered",
              showToast: true,
              role: "error",
            });
          } else {
            setIsAlready(false);
            const { data: cinDetails } = result;
            const companyName = cinDetails["Company Name"]
            const CIN = cinDetails["CIN "]; 
            validation.setFieldValue("entityName", companyName);
            const registeredAddresses = cinDetails["Registered Address"];

            if (CIN.includes("PTC") || CIN.includes("FTC")) {
              validation.setFieldValue("entityConstitution" , "Private Limited Company");
            } else if (CIN.includes("PLC")) {
              validation.setFieldValue("entityConstitution" , "Public Limited Company");
            } else if (CIN.includes("STP")) {
              validation.setFieldValue("entityConstitution", "Proprietorship");
            } else {
              validation.setFieldValue("entityConstitution", "");
            }

            let addressToUse;

            if (registeredAddresses.length > 1) {
              addressToUse = registeredAddresses.find(address => address.addressType === "Registered Address");
            } else {
              addressToUse = registeredAddresses[0];
            }
            if (addressToUse) {
              validation.setFieldValue("address1", addressToUse.streetAddress || "");
              validation.setFieldValue("address2", addressToUse.streetAddress2 || "");
              validation.setFieldValue("address3", addressToUse.streetAddress3 || "");
              validation.setFieldValue("pincode", addressToUse.postalCode || "");
              validation.setFieldValue("addressType", "registered_business_address");

              const state = addressToUse.state || "";
              if (stateList && state) {
                validation.setFieldValue("state", state.toUpperCase());
                getCityList(state.toUpperCase());
              }

              const city = addressToUse.city || "";
              if (cityList && city) {
                validation.setFieldValue("city", city.toUpperCase());
              }
            }

          }
        } else {
          setToastInfo({
            message: result?.message || "Incorrect CIN",
            showToast: true,
            role: "error",
          });
          validation.setFieldValue("entityName", "");
          validation.setFieldValue("entityConstitution", "");
        }
      })
      .catch((e) => {
        setToastInfo({
          message: "CIN not found",
          showToast: true,
          role: "error",
        });
        validation.setFieldValue("companyName", "");
        validation.setFieldValue("constitution", "");
      })
      .finally((f) => {
        setLoader(false);
      });
  };

  const findGSTINDetails = (gstin) => {
    setLoader(true);
    callGetGSTINDetails({ gstnIn: gstin })
      .then(async (result) => {
        if (result.code == 200 && result.status) {
          if (await checkIfalreadyExist({gstnIn:gstin})) {
            setIsAlready(true);
            setToastInfo({
              message: "GSTIN already registered",
              showToast: true,
              role: "error",
            });
          } else {
            setIsAlready(false);
            const { data: gstinDetails } = result;
            const { tradeNam, ctb, rgdt } = gstinDetails;
            const { stcd, dst, pncd, bnm, flno, landMark } =
              gstinDetails.pradr.addr;
            validation.setFieldValue("entityName", tradeNam);
            validation.setFieldValue("entityConstitution", ctb);
            validation.setFieldValue("address1", bnm);
            validation.setFieldValue("address2", flno);
            validation.setFieldValue("address3", landMark);
            validation.setFieldValue("pincode", pncd);
            validation.setFieldValue("addressType", "registered_business_address");
            validation.setFieldValue(
              "dateOfIncorporation",
              dateFormatChange(rgdt, "DD/MM/YYYY", "YYYY-MM-DD")
            );
            if (stateList && stcd) {
              validation.setFieldValue("state", stcd.toUpperCase());
              getCityList(stcd)
            }
            if (cityList && dst) {
              validation.setFieldValue("city", dst.toUpperCase());
            }

            validation.setFieldValue("pan", gstin.substring(2, 12));
          }
        } else {
          setToastInfo({
            message: "Incorrect GSTIN",
            showToast: true,
            role: "error",
          });
          validation.setFieldValue("entityName", "");
          validation.setFieldValue("entityConstitution", "");
        }
      })
      .catch((e) => {
        setToastInfo({
          message: "GSTIN not found",
          showToast: true,
          role: "error",
        });
        validation.setFieldValue("companyName", "");
        validation.setFieldValue("constitution", "");
      })
      .finally((f) => {
        setLoader(false);
      });
  };

  const checkIfalreadyExist = async (value) => {
    let status = await checkEntityExistOrNot(value)
    return status.status
  }

  const findPanDetails = (pan) => {
    setLoader(true);
    callGetPanDetails({ pan: pan })
      .then(async(result) => {
        if (result.code == 200 && result.data.status !== "INVALID" && await checkIfalreadyExist({ pan: pan })) {
          setIsAlready(true);
          setToastInfo({
            message: "PAN already registered",
            showToast: true,
            role: "error",
          });
        } else if (result.code == 200 && result.data.status !== "INVALID") {
          setIsAlready(false);
          const { data: panDetails } = result;
          const { full_name, category } = panDetails;
          validation.setFieldValue("entityName", full_name);
          if (category == "Company") {
            validation.setFieldValue("entityConstitution", "Private Limited Company");
          } else if (category == "Firm") {
            validation.setFieldValue("entityConstitution", "Partnership");
          } else if (category == "Individual") {
            validation.setFieldValue("entityConstitution", "Proprietorship");
          }
        } else {
          setToastInfo({
            message: "Incorrect PAN",
            showToast: true,
            role: "error",
          });
          validation.setFieldValue("entityName", "");
          validation.setFieldValue("entityConstitution", "");
        }
      })
      .catch((e) => {
        setToastInfo({
          message: "PAN not found",
          showToast: true,
          role: "error",
        });
        validation.setFieldValue("entityName", "");
        validation.setFieldValue("entityConstitution", "");
      })
      .finally((f) => {
        setLoader(false);
      });
  };

  useEffect(() => {
    let userDetails = decryptedValue(localStorage.getItem("user"));
    getDropDownList({ dropdownName: "Entity Type" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Entity Type")
            ?.dropdownValues || [];
        setEntityTypeList(dropdownValues);
      })
      .catch((error) => { });
    getDropDownList({ dropdownName: "Ratings" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Ratings")
            ?.dropdownValues || [];
        setRatingList(dropdownValues);
      })
      .catch((error) => { });
    getDropDownList({ dropdownName: "agency_names" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "agency_names")
            ?.dropdownValues || [];
        setAgencyNameList(dropdownValues);
      })
      .catch((error) => { });
    getDropDownList({ dropdownName: "region" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "region")
            ?.dropdownValues || [];
        setReigonList(dropdownValues);
      })
      .catch((error) => { });
    callGetState()
      .then((response) => {
        if (response.code == "200") {
          setStateList(response.data);
        }
      })
      .catch((error) => { });
    if (userDetails.entityType == 'Partner') {
      getRoleByEntityType({ searchKey: 'Customer' })
        .then((response) => {
          if (response.status) {
            setRoleList(response.data.data)
          }
        })
        .catch((error) => {

        });
      validation.setFieldValue('entityType', 'Customer')
      getDropDownList({
        dropdownName: "Non-Financier Type",
      })
        .then((response) => {
          const dropdownValues =
            response.data?.rows?.find(
              (dv) =>
                dv.dropdownName == "Non-Financier Type"
            )?.dropdownValues || [];
          setIsNonFinSelected(true);
          setIsFinSelected(false)
          setNonFinTypeList(dropdownValues);
        })
        .catch((error) => { }); 
    }
    getDropDownList({
      dropdownName: "Non-Financier Type",
    })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find(
            (dv) =>
              dv.dropdownName == "Non-Financier Type"
          )?.dropdownValues || [];
        setIsNonFinSelected(true);
        setIsFinSelected(false)
        setNonFinTypeList(dropdownValues);
      })
      .catch((error) => { });
    //Getting Program manager
    getCIUserRolewise({role:"Program Manager"})
    .then((response) => {
      if (response.status) {
        setManagerList(response.data.rows)
      }
    })
    .catch((error) => {
       console.log(error);
    });

    //Getting RM
    callGetCIUser()
      .then((res) => {
        setOwnerList(res.data.rows)
      })

    //Getting FI Manager
    getCIUserRolewise({role:"FI RM"})
    .then((response) => {
      if (response.status) {
        setPartnerList(response.data.rows)
      }
    })
    .catch((error) => {
       console.log(error);
    });
    if (decodedEntityType == 'Financier') {
      validation.setFieldValue('entityType', 'Financier')
      setIsNonFinSelected(false);
      setIsMSMESelected(false);
      getDropDownList({
        dropdownName: "financier_type",
      })
        .then((response) => {
          const dropdownValues =
            response.data?.rows?.find(
              (dv) =>
                dv.dropdownName == "financier_type"
            )?.dropdownValues || [];
          setIsNonFinSelected(false);
          setIsCounterparty(false);

          setIsFinSelected(true)
          setFinTypeList(dropdownValues);
        })
        .catch((error) => { });
    }
    if (decodedEntityType) {
      getRoleByEntityType({ searchKey: decodedEntityType })
        .then((response) => {
          if (response.status) {
            setRoleList(response.data.data)
          }
        })
        .catch((error) => {

        });
    }
  }, []);

  useEffect(() => {
    loadAnchorList()
    if (isNonFinSelected) {
      getDropDownList({ dropdownName: "msme_nonMsme" })
        .then((response) => {
          const values =
            response.data?.rows?.find((dv) => dv.dropdownName === "msme_nonMsme")
              ?.dropdownValues || [];
          setMsmeDropDown(values);
        })
        .catch((error) => {
          console.error("Error fetching dropdown values:", error);
        });
    }
  }, [isNonFinSelected]);

  
  const anchorValues = useAsyncDebounce((value) => {
    loadAnchorList(value);
  }, 500);


  const loadAnchorList = (search) => {
    callAnchorList({ page: 1, limit: 200, searchKey: search })
      .then((response) => {
        const formattedOptions = response?.data.data.map((option) => ({
          label: option.entityName,
          value: option.id,
        }));
        setAnchorList(formattedOptions);
        return formattedOptions;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleMulti = (selectedOptions) => {
    const newData = selectedOptions.map((ele) => ele.value);
    validation.setFieldValue("anchors", newData); // Update anchors field
    setSelectedMulti(selectedOptions);
  };

  const handleChangeradio = (e, option) => {
    setMsmeType(option.displayName);
    validation.setFieldValue("msmeNonmsme", option.displayName);
    if (option.displayName === "MSME") {
      getDropDownList({ dropdownName: "MSME Type" })
        .then((response) => {
          const dropdownValues =
            response.data?.rows?.find((dv) => dv.dropdownName === "MSME Type")
              ?.dropdownValues || [];
          setIsMSMESelected(true);
          setMsmeTypeList(dropdownValues);
        })
        .catch((error) => {
          console.error("Error fetching MSME Type dropdown values:", error);
        });
    } else {
      setIsMSMESelected(false);
    }

    validation.handleChange(e);
  };

  const handleCancel = () => {
    window.history.back();
  };

  function setStateValue(data, state) {
    if (state) {
      for (const item of data) {
        if (item.name === state) {
          const value = { label: `${item.name}`, value: state };
          return value;
        }
      }
    }
  }

  function setCityValue(data, city) {
    if (city) {
      for (const item of data) {
        if (item.cityName === city) {
          const value = { label: `${item.cityName}`, value: city };
          return value;
        }
      }
    } else {
      return null
    }
  }


  const handleInputChange = (value) => {
    validation.setFieldValue("state", value);
    validation.setFieldValue("city", "")
    getCityList(value)
  };

  const handleCityChange = (value) => {
    validation.setFieldValue("city", value);
  };

  const getCityList = (value) => {
    callGetCity({ state: value })
      .then((response) => {
        if (response.status) {
          setCityList(response?.data)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const formatUdyamNumber = (value) => {
    value = value.replace(/[^a-zA-Z0-9]/g, '');
    value = value.toUpperCase();
    if (value.length > 5) value = `${value.slice(0, 5)}-${value.slice(5)}`;
    if (value.length > 8) value = `${value.slice(0, 8)}-${value.slice(8)}`;
    if (value.length > 11) value = `${value.slice(0, 11)}-${value.slice(11)}`;
    return value;
  };
  
  const handleUdyamNumberChange = (e) => {
    const value = e.target.value;
    findudyamnumber(value);
  };
  
  const findudyamnumber = (udyamNumber) => {
    setLoader(true);
    callCheckUdyamNumber({ udyamNumber })
      .then(async (result) => {
        if (result.code == 200 && result.status) {
            setIsAlready(true);
            setToastInfo({
              message: "Udyam number already registered",
              showToast: true,
              role: "error",
            });
          } else {
            const formattedValue = formatUdyamNumber(udyamNumber);
            validation.setFieldValue('udyamNumber', formattedValue);
            setIsAlready(false);
          }
      })
      .catch((e) => {
        setToastInfo({
          message: "Udyam number not found",
          showToast: true,
          role: "error",
        });
        validation.setFieldValue("udyamNumber", "");
      })
      .finally(() => {
        setLoader(false);
      });
  }; return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Add Entity" />
          <Row className="vertical-scroll">
            <Col xs="12">
              <div>
                <div>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="mb-3 row">
                      <Col sm="12" md="6">
                        <Label className="required-sign form-label">GSTIN</Label>
                        <Input
                          name="gstnIn"
                          type="text"
                          placeholder="Enter GSTIN"
                          onChange={(e) => {
                            validation.handleChange(e);
                            onGSTINChange(e.target.value);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.gstnIn || ""}
                          invalid={
                            validation.touched.gstnIn &&
                            validation.errors.gstnIn
                          }
                        />
                        {validation.touched.gstnIn &&
                          validation.errors.gstnIn ? (
                          <FormFeedback type="invalid">
                            {validation.errors.gstnIn}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm="12" md="6">
                        <Label className="required-sign form-label">PAN</Label>
                        <Input
                          name="pan"
                          type="text"
                          placeholder="Enter PAN"
                          onChange={(e) => {
                            validation.handleChange(e);
                            onPanChange(e.target.value);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.pan || ""}
                          invalid={
                            validation.touched.pan && validation.errors.pan
                          }
                        />
                        {validation.touched.pan && validation.errors.pan ? (
                          <FormFeedback type="invalid">
                            {validation.errors.pan}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4">
                          CIN
                        </Label>
                        <Input
                          name="cin"
                          type="text"
                          placeholder="Enter CIN"
                          onChange={(e) => {
                            validation.handleChange(e);
                            onCINChange(e.target.value);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.cin || ""}
                          invalid={
                            validation.touched.cin && validation.errors.cin
                          }
                        />
                        {validation.touched.cin && validation.errors.cin ? (
                          <FormFeedback type="invalid">
                            {validation.errors.cin}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4">Entity Name <i className="mdi mdi-asterisk"></i></Label>
                        <Input
                          name="entityName"
                          type="text"
                          placeholder="Enter Entity Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.entityName || ""}
                          invalid={
                            validation.touched.entityName &&
                            validation.errors.entityName
                          }
                        />
                        {validation.touched.entityName &&
                          validation.errors.entityName ? (
                          <FormFeedback type="invalid">
                            {validation.errors.entityName}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4">
                          Entity Constitution <i className="mdi mdi-asterisk"></i>
                        </Label>
                        <Input
                          name="entityConstitution"
                          type="select"
                          placeholder="Enter Entity constitution"
                          onChange={(e) => {
                            validation.handleChange(e);
                            if (e.target.value == 'Private Limited Company' || e.target.value == 'Public Limited Company') {
                              setIsConstitution(true)
                            } else {
                              setIsConstitution(false)
                            }
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.entityConstitution || ""}
                          invalid={
                            validation.touched.entityConstitution &&
                            validation.errors.entityConstitution
                          }
                        >
                          <option value="" disabled>
                            Select Entity Constitution
                          </option>
                          <option value="Private Limited Company">
                            Private Limited Company
                          </option>
                          <option value="Limited Liability Partnership">
                            Limited Liability Partnership
                          </option>
                          <option value="Proprietorship">Proprietorship</option>
                          <option value="Partnership">Partnership</option>
                          <option value="Public Limited Company">
                            Public Limited Company
                          </option>
                        </Input>
                        {validation.touched.entityConstitution &&
                          validation.errors.entityConstitution ? (
                          <FormFeedback type="invalid">
                            {validation.errors.entityConstitution}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Date of Incorporation 
                        </Label>
                        <Input
                          name="dateOfIncorporation"
                          type="date"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.dateOfIncorporation || ""}
                          invalid={
                            validation.touched.dateOfIncorporation &&
                            validation.errors.dateOfIncorporation
                          }
                          max={currentDate}
                        />
                        {validation.touched.dateOfIncorporation &&
                          validation.errors.dateOfIncorporation ? (
                          <FormFeedback type="invalid">
                            {validation.errors.dateOfIncorporation}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      {userDetails.entityType == 'Owner' && (<Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4">
                          Select Entity type <i className="mdi mdi-asterisk"></i>
                        </Label>
                        <Input
                          name="entityType"
                          type="select"
                          onChange={(e) => {
                            getRoleByEntityType({ searchKey: e.target.value })
                              .then((response) => {
                                if (response.status) {
                                  if(e.target.value == 'Customer'){
                                    if(response?.data?.data[0]?.id){
                                      validation.setFieldValue('roleId',response?.data?.data[0]?.id)
                                    }
                                  }
                                  setRoleList(response.data.data)
                                }
                              })
                              .catch((error) => {

                              });
                            if (e.target.value == "Customer") {
                              getDropDownList({
                                dropdownName: "Non-Financier Type",
                              })
                                .then((response) => {
                                  const dropdownValues =
                                    response.data?.rows?.find(
                                      (dv) =>
                                        dv.dropdownName == "Non-Financier Type"
                                    )?.dropdownValues || [];
                                  setIsNonFinSelected(true);
                                  setIsFinSelected(false)
                                  // setMsmeTypeSelected(false);
                                  // setIsMSMESelected()
                                  setNonFinTypeList(dropdownValues);
                                })
                                .catch((error) => { });
                            } else {
                              setIsNonFinSelected(false);
                              setIsMSMESelected(false);
                              getDropDownList({
                                dropdownName: "financier_type",
                              })
                                .then((response) => {
                                  const dropdownValues =
                                    response.data?.rows?.find(
                                      (dv) =>
                                        dv.dropdownName == "financier_type"
                                    )?.dropdownValues || [];
                                  setIsNonFinSelected(false);
                                  setIsCounterparty(false);
                                  
                                  setIsFinSelected(true)
                                  setFinTypeList(dropdownValues);
                                })
                                .catch((error) => { });
                            }
                            validation.handleChange(e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.entityType || ""}
                          invalid={
                            validation.touched.entityType &&
                            validation.errors.entityType
                          }
                        >
                          <option value="" disabled>
                            Select Entity Type
                          </option>
                          {entityTypeList.map((option) => (
                            <option key={uId()} value={option.dropdownValue}>
                              {option.displayName}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.entityType &&
                          validation.errors.entityType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.entityType}
                          </FormFeedback>
                        ) : null}
                      </Col>)}
                      
                      {isNonFinSelected && (
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">
                            Non Financier (Entity)Type 
                          </Label>
                          <Input
                            name="nonFinancierType"
                            type="select"
                            onChange={(e) => {
                            
                              if (e.target.value == "Counterparty") {
                                setIsCounterparty(true);
                              }
                              else {
                                setIsCounterparty(false);
                              }
                              validation.handleChange(e);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.nonFinancierType || ""}
                            invalid={
                              validation.touched.nonFinancierType &&
                              validation.errors.nonFinancierType
                            }
                          >
                            <option value="" disabled>
                              Select Non financier (Entity)Type
                            </option>
                            {nonFinTypeList.map((option) => (
                              <option key={uId()} value={option.dropdownValue}>
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.nonFinancierType &&
                            validation.errors.nonFinancierType ? (
                            <FormFeedback type="invalid">
                              {validation.errors.nonFinancierType}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      )}
                      {isCounterparty && (
                        <Col sm="12" md="6">
                          <Label className="required-sign form-label mt-4">
                            Select Associate Anchors<i className="mdi mdi-asterisk"></i>
                          </Label>
                         
                            <div>
                              <Select
                                name="anchor"
                                value={selectedMulti}
                                isMulti={true}
                                onChange={handleMulti}
                                onKeyDown={(e) => {
                                  anchorValues(e.target.value);
                                }}
                                options={anchorList}
                                className={`select2-selection mb-2 ${validation.touched.anchors && validation.errors.anchors ? "is-invalid" : ""}`}
                              />
                            {validation.touched.anchors && validation.errors.anchors ? (
                              <FormFeedback type="invalid">
                                {validation.errors.anchors}
                              </FormFeedback>
                            ) : null}
                          </div>           
                          {selectedAnchors === "select" && (
                            <div>
                              <span style={{ fontWeight: "500" }}>
                                Select Anchors 
                              </span>
                              <Select
                                name="anchor"
                                value={selectedMulti}
                                isMulti={true}
                                onChange={handleMulti}
                                onKeyDown={(e) => {
                                  anchorValues(e.target.value);
                                }}
                                options={anchorList}
                                className="select2-selection mb-2"
                              />

                            </div>
                          )}
                        </Col>
                      )}
                       {isNonFinSelected && (
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">
                            MSME / Non-MSME
                          </Label>
                          {msmeDropDown.map((option) => (
                            <div key={option.dropdownValue}>
                              <Input
                                type="radio"
                                name="msmeNmsme"
                                value={option.displayName|| ""}
                                checked={msmeNmsme === option.displayName}
                                onChange={(e) => handleChangeradio(e, option)
                                }
                                onBlur={validation.handleBlur}
                                invalid={
                                  validation.touched.msmeNonmsme &&
                                  validation.errors.msmeNonmsme
                                }
                                style={{ marginRight: '10px' }}
                              />
                              <Label check>{option.displayName}</Label>
                            </div>
                          ))}
                        {validation.touched.msmeNonmsme &&
                            validation.errors.msmeNonmsme ? (
                            <FormFeedback type="invalid">
                              {validation.errors.msmeNonmsme}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      )}
                      
                      {isMSMESelected && (
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">Select MSME Type </Label>
                          <Input
                            name="msmeType"
                            type="select"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.msmeType || ""}
                            invalid={validation.touched.msmeType && validation.errors.msmeType}
                          >
                            <option value="" disabled>
                              Select MSME Type
                            </option>
                            {msmeTypeList.map((option) => (
                              <option key={option.dropdownValue} value={option.dropdownValue}>
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.msmeType && validation.errors.msmeType && (
                            <FormFeedback type="invalid">
                              {validation.errors.msmeType}
                            </FormFeedback>
                          )}
                        </Col>
                      )}

                      {isMSMESelected && (
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">Enter Udyam Number </Label>
                          <Input
                          name="udyamNumber"
                          type="text"
                          placeholder="Enter Udyam Number"
                          onChange={handleUdyamNumberChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.udyamNumber || ""}
                          invalid={
                            validation.touched.udyamNumber &&
                            validation.errors.udyamNumber
                          }
                        />
                        {validation.touched.udyamNumber &&
                          validation.errors.udyamNumber ? (
                          <FormFeedback type="invalid">
                            {validation.errors.udyamNumber}
                          </FormFeedback>
                        ) : null}
                        </Col>
                      )}

                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4">
                          Select Region<i className="mdi mdi-asterisk"></i>
                        </Label>   
                        <Input
                          name="region"
                          type="select"
                          onChange={(e) => {
                            validation.handleChange(e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.region || ""}
                          invalid={
                            validation.touched.region &&
                            validation.errors.region
                          }
                        >
                          <option value="" disabled>
                            Select Region 
                          </option>
                          {regionList.map((option) => (
                            <option key={uId()} value={option.dropdownValue}>
                              {option.displayName}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.region &&
                          validation.errors.region ? (
                          <FormFeedback type="invalid">
                            {validation.errors.region}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      {isNonFinSelected && (
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">
                            Enter Turnover (₹)
                          </Label>
                          <Input
                            name="turnOver"
                            type="text"
                            placeholder="Enter turnover"
                            onChange={(e) => {
                              validation.handleChange(e);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.turnOver || ""}
                            invalid={
                              validation.touched.turnOver &&
                              validation.errors.turnOver
                            }
                          />
                          {validation.touched.turnOver &&
                            validation.errors.turnOver ? (
                            <FormFeedback type="invalid">
                              {validation.errors.turnOver}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      )}
                      {isCounterparty && (
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">
                            Total Purchases (₹)
                          </Label>
                          <Input
                            name="totalPurchase"
                            type="text"
                            placeholder="Enter total purchases"
                            onChange={(e) => {
                              validation.handleChange(e);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.totalPurchase || ""}
                            invalid={
                              validation.touched.totalPurchase &&
                              validation.errors.totalPurchase
                            }
                          />
                        </Col>
                      )}
                      <Col sm="12" md="6">
                          <Label className="required-sign form-label mt-4">
                          Select Relationship Manager <i className="mdi mdi-asterisk"></i>
                          </Label>
                          <Input
                            name="programOwner"
                            type="select"
                            placeholder="Select Relationship Manager"
                            onChange={(e) => {
                              validation.handleChange(e);
                            }}
                            value={validation.values.programOwner || ""}
                            invalid={
                              validation.touched.programOwner &&
                              validation.errors.programOwner
                            }
                          >
                            <option value="" disabled>Select Relationship Manager</option>
                            {ownerList.map((data) => (
                                <option key={data.id} value={data.id}>
                                  {data.firstName} {data.lastName} 
                                </option>
                              ))}
                            
                          </Input>
                          {validation.touched.programOwner &&
                          validation.errors.programOwner ? (
                          <FormFeedback type="invalid">
                            {validation.errors.programOwner}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Company Description
                        </Label>
                        <Input
                          name="companyDescription"
                          type="textarea"
                          placeholder="Company Description"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.companyDescription || ""}
                        />
                      </Col>

                      {isNonFinSelected && (
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">
                            Nature Of Business 
                          </Label>
                          <Input
                            name="natureOfBusiness"
                            type="select"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.natureOfBusiness || ""}
                            invalid={
                              validation.touched.natureOfBusiness &&
                              validation.errors.natureOfBusiness
                            }
                          >
                            <option value="" disabled>
                              Select Nature Of Business
                            </option>
                            <option value="Services">Services</option>
                            <option value="Retialer">Retailer</option>
                            <option value="Trader">Trader</option>
                            <option value="Manufacturing">Manufacturing</option>
                            <option value="Wholesaler">Wholesaler</option>
                            <option value="Distributor">Distributor</option>
                            <option value="Agriculture & Allied Activities">
                              Agriculture & Allied Activities
                            </option>
                            <option value="Non Profit Organization">
                              Non Profit Organization
                            </option>
                            <option value="Others">Others</option>
                          </Input>
                          {validation.touched.natureOfBusiness &&
                            validation.errors.natureOfBusiness ? (
                            <FormFeedback type="invalid">
                              {validation.errors.natureOfBusiness}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      )}

                      {isFinSelected && (
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">
                            Select Financier type 
                          </Label>
                          <Input
                            name="financierType"
                            type="select"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.financierType || ""}
                            invalid={
                              validation.touched.financierType &&
                              validation.errors.financierType
                            }
                          >
                            <option value="" disabled>
                              Select Financier Type
                            </option>
                            {finTypeList.map((option) => (
                              <option key={uId()} value={option.dropdownValue}>
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.financierType &&
                            validation.errors.financierType ? (
                            <FormFeedback type="invalid">
                              {validation.errors.financierType}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      )}

                      </div>
                      <div
                        style={{
                          marginTop: "3%",
                          borderTop: "1px solid #f0f0f0",
                        }}
                      >
                        <h5 style={{ marginTop: "1%" }}>Credit rating</h5>
                      </div>
                      <div className="mb-3 row">
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">
                            Select Agency 
                          </Label>
                          <Input
                            name="agencyName"
                            type="select"
                            onChange={(e) => {
                              validation.handleChange(e);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.agencyName || ""}
                            invalid={
                              validation.touched.agencyName &&
                              validation.errors.agencyName
                            }
                          >
                            <option value="" disabled>
                              Select Agency 
                            </option>
                            {agencyNameList.map((option) => (
                              <option key={uId()} value={option.dropdownValue} title={option.displayName}>
                                {option.dropdownValue}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.agencyName &&
                            validation.errors.agencyName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.agencyName}
                            </FormFeedback>
                          ) : null}
                        </Col>
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">
                            Select Credit Rating 
                          </Label>
                          <Input
                            name="creditRating"
                            type="select"
                            onChange={(e) => {
                              validation.handleChange(e);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.creditRating || ""}
                            invalid={
                              validation.touched.creditRating &&
                              validation.errors.creditRating
                            }
                          >
                            <option value="" disabled>
                              Select Credit Rating 
                            </option>
                            {ratingList.map((option) => (
                              <option key={uId()} value={option.dropdownValue}>
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.creditRating &&
                            validation.errors.creditRating ? (
                            <FormFeedback type="invalid">
                              {validation.errors.creditRating}
                            </FormFeedback>
                          ) : null}
                        </Col>
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">
                            Rated Date 
                          </Label>
                          <Input
                            name="ratedDate"
                            type="date"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={formatDateString1(validation.values.ratedDate) || ""}
                            invalid={
                              validation.touched.ratedDate &&
                              validation.errors.ratedDate
                            }
                            max={currentDate}
                          />
                          {validation.touched.ratedDate &&
                            validation.errors.ratedDate ? (
                            <FormFeedback type="invalid">
                              {validation.errors.ratedDate}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </div>
                      <div
                        style={{
                          marginTop: "3%",
                          borderTop: "1px solid #f0f0f0",
                        }}
                      >
                        <h5 style={{ marginTop: "1%" }}>Entity Contact</h5>
                      </div>
                      <div className="mb-3 row">
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4" >First Name</Label>
                        <Input
                          name="firstname"
                          type="text"
                          placeholder="Enter first name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.firstname || ""}
                          invalid={
                            validation.touched.firstname &&
                              validation.errors.firstname
                              ? true
                              : false
                          }
                        />
                        {validation.touched.firstname &&
                          validation.errors.firstname ? (
                          <FormFeedback type="invalid">
                            {validation.errors.firstname}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4" >Last Name</Label>
                        <Input
                          name="lastname"
                          type="text"
                          placeholder="Enter last name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.lastname || ""}
                          invalid={
                            validation.touched.lastname &&
                              validation.errors.lastname
                              ? true
                              : false
                          }
                        />
                        {validation.touched.lastname &&
                          validation.errors.lastname ? (
                          <FormFeedback type="invalid">
                            {validation.errors.lastname}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4" >Email</Label>
                        <Input
                          name="email2"
                          type="text"
                          placeholder="Enter Email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email2 || ""}
                          invalid={
                            validation.touched.email2 &&
                              validation.errors.email2
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email2 &&
                          validation.errors.email2 ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email2}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Contact Number </Label>
                        <Input
                          name="contactNumber"
                          type="text"
                          placeholder="Enter mobile number"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.contactNumber || ""}
                          invalid={
                            validation.touched.contactNumber &&
                              validation.errors.contactNumber
                              ? true
                              : false
                          }
                        />
                        {validation.touched.contactNumber &&
                          validation.errors.contactNumber ? (
                          <FormFeedback type="invalid">
                            {validation.errors.contactNumber}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Designation</Label>
                        <Input
                          name="designation"
                          type="text"
                          placeholder="Enter designation"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.designation || ""}
                          invalid={
                            validation.touched.designation &&
                              validation.errors.designation
                              ? true
                              : false
                          }
                        />
                        {validation.touched.designation &&
                          validation.errors.designation ? (
                          <FormFeedback type="invalid">
                            {validation.errors.designation}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Date of Birth 
                        </Label>
                        <Input
                          name="dateOfBirth"
                          type="date"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.dateOfBirth ? formatDateString1(validation.values.dateOfBirth) : ""}
                          invalid={
                            validation.touched.dateOfBirth &&
                            validation.errors.dateOfBirth
                          }
                          max={currentDate}
                        />
                        {validation.touched.dateOfBirth &&
                          validation.errors.dateOfBirth ? (
                          <FormFeedback type="invalid">
                            {validation.errors.dateOfBirth}
                          </FormFeedback>
                        ) : null}
                      </Col>

                        
                    </div>

                    <div
                      style={{
                        marginTop: "3%",
                        borderTop: "1px solid #f0f0f0",
                      }}
                    >
                      <h5 style={{ marginTop: "1%" }}>Address</h5>
                    </div>

                    <div className="mb-3 row">
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Address Type </Label>
                        <Input
                          name="addressType"
                          type="select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.addressType || ""}
                          invalid={
                            validation.touched.addressType &&
                            validation.errors.addressType
                          }
                        >
                          <option value="" disabled>
                            Select address type
                          </option>
                          <option value="registered_business_address">
                            Registered Business Address
                          </option>
                          <option value="head_office_address">
                            Head Office Address
                          </option>
                        </Input>
                        {validation.touched.addressType &&
                          validation.errors.addressType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.addressType}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Address Line1 
                        </Label>
                        <Input
                          name="address1"
                          type="text"
                          placeholder="Enter Address Line1"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address1 || ""}
                          invalid={
                            validation.touched.address1 &&
                            validation.errors.address1
                          }
                        />
                        {validation.touched.address1 &&
                          validation.errors.address1 ? (
                          <FormFeedback type="invalid">
                            {validation.errors.address1}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Address Line2</Label>
                        <Input
                          name="address2"
                          type="text"
                          placeholder="Enter Address Line2"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address2 || ""}
                          invalid={
                            validation.touched.address2 &&
                            validation.errors.address2
                          }
                        />
                        {validation.touched.address2 &&
                          validation.errors.address2 ? (
                          <FormFeedback type="invalid">
                            {validation.errors.address2}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Address Line3</Label>
                        <Input
                          name="address3"
                          type="text"
                          placeholder="Enter Address Line3"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address3 || ""}
                          invalid={
                            validation.touched.address3 &&
                            validation.errors.address3
                          }
                        />
                        {validation.touched.address3 &&
                          validation.errors.address3 ? (
                          <FormFeedback type="invalid">
                            {validation.errors.address3}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">State </Label>
                        <Select
                          options={stateList.map((option) => ({
                            label: option.name,
                            value: option.name,
                          }))}
                          className={`select-dropdown ${validation.touched.state && validation.errors.state
                            ? "is-invalid"
                            : ""
                            }`}
                          name="state"
                          id="state"
                          onChange={(selectedOption) => {
                            handleInputChange(selectedOption.value);
                          }}
                          value={setStateValue(
                            stateList,
                            validation.values.state
                          )}
                        />
                        {validation.touched.state && validation.errors.state ? (
                          <FormFeedback type="invalid">
                            {validation.errors.state}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">City </Label>
                        <Select
                          options={cityList.map((option) => ({
                            label: option.cityName,
                            value: option.cityName,
                          }))}
                          className={`select-dropdown ${validation.touched.city && validation.errors.city
                            ? "is-invalid"
                            : ""
                            }`}
                          name="city"
                          id="city"
                          onChange={(selectedOption) => {
                            handleCityChange(selectedOption.value);
                          }}
                          value={setCityValue(
                            cityList,
                            validation.values.city
                          )}
                          invalid={
                            validation.touched.city &&
                            validation.errors.city
                          }
                        />
                        {validation.touched.city && validation.errors.city ? (
                          <FormFeedback type="invalid">
                            {validation.errors.city}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Pincode </Label>
                        <Input
                          name="pincode"
                          type="text"
                          placeholder="Enter Pincode"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.pincode || ""}
                          invalid={
                            validation.touched.pincode &&
                            validation.errors.pincode
                          }
                        />
                        {validation.touched.pincode &&
                          validation.errors.pincode ? (
                          <FormFeedback type="invalid">
                            {validation.errors.pincode}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </div>

                    <div
                      style={{
                        marginTop: "3%",
                        borderTop: "1px solid #f0f0f0",
                      }}
                    >
                      <h5
                        style={{ marginTop: "1%", cursor: "pointer" }}
                        onClick={handlClick}
                      >
                        + Add User
                      </h5>
                    </div>

                    {isOpen && (
                      <div className="mb-3 row">
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">First Name*</Label>
                          <Input
                            name="firstName"
                            type="text"
                            placeholder="Enter First Name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.firstName || ""}
                            invalid={
                              validation.touched.firstName &&
                              validation.errors.firstName
                            }
                          />
                          {validation.touched.firstName &&
                            validation.errors.firstName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.firstName}
                            </FormFeedback>
                          ) : null}
                        </Col>

                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">Last Name*</Label>
                          <Input
                            name="lastName"
                            type="text"
                            placeholder="Enter Last Name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.lastName || ""}
                            invalid={
                              validation.touched.lastName &&
                              validation.errors.lastName
                            }
                          />
                          {validation.touched.lastName &&
                            validation.errors.lastName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.lastName}
                            </FormFeedback>
                          ) : null}
                        </Col>

                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">Email*</Label>
                          <Input
                            name="email"
                            type="email"
                            placeholder="Enter Email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                            }
                          />
                          {validation.touched.email &&
                            validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </Col>

                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">Mobile No.*</Label>
                          <Input
                            name="mobileNo"
                            type="number"
                            placeholder="Enter Mobile No"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.mobileNo || ""}
                            invalid={
                              validation.touched.mobileNo &&
                              validation.errors.mobileNo
                            }
                          />
                          {validation.touched.mobileNo &&
                            validation.errors.mobileNo ? (
                            <FormFeedback type="invalid">
                              {validation.errors.mobileNo}
                            </FormFeedback>
                          ) : null}
                        </Col>

                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">Role*</Label>
                          <Input
                            name="roleId"
                            type="select"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.roleId || ""}
                            invalid={validation.touched.roleId && validation.errors.roleId}
                          >
                            <option value="" disabled>Select Role Type</option>
                            {roleList.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.displayName}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.roleId && validation.errors.roleId ? (
                            <FormFeedback type="invalid">{validation.errors.roleId}</FormFeedback>
                          ) : null}
                        </Col>
                      </div>
                    )}

                    <Row>
                      {!isAlready && (
                        <Col>
                          <div className="d-flex gap-3 justify-content-end">
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              onClick={handleCancel}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className="btn btn-success save-customer"
                            >
                              Save
                            </button>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      <Loader show={loader} type="box" message="Fetching Data" />
      <Loader show={saveLoader} type="box" message="Saving Entity Details" />
    </React.Fragment>
  );
 
};

export default withRouter(AddEntity);

AddEntity.propTypes = {
  history: PropTypes.object,
};
